//Assessments modules
import formulaBuilderTypes from "./formulaBuilderTypes"
import RenderOperator from "./RenderFormula/RenderOperator"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import FormulaBuilderGroupingPanel from "./FormulaBuilderGroupingPanel"

export default function FormulaBuilderOperators({
  activeOperator,
  onActivate,
}) {
  const operators = formulaBuilderTypes.operators

  return (
    <>
      <FormulaBuilderGroupingPanel title="Operators">
        Click on an operator to make it the default. Drag one onto another to
        swap it, or drag the group operator to add a new group.
      </FormulaBuilderGroupingPanel>

      <div className={myStyles.operatorContainer}>
        {operators.map((operatorItem) => (
          <RenderOperator
            operatorItem={operatorItem}
            isActive={activeOperator === operatorItem.name}
            onActivate={onActivate}
          />
        ))}
      </div>
    </>
  )
}
